import React from "react";

const SystemSettings = () => {
  return (
    <div>
      <h5>System Settings</h5>

      <p className="text-muted">
        Configure general POS system settings.
      </p>

      <div className="alert alert-info">
        <i className="bi bi-info-circle me-2"></i>

        System configuration options will be added here.
      </div>
    </div>
  );
};

export default SystemSettings;